import React, { useEffect, useId, useRef, useState } from 'react';
import { splitContactName } from '../../lib/contactNames';

export default function ContactNameFields({ value = '', firstName, lastName, onChange, disabled = false, className = '', labelClassName = '', idPrefix }) {
    const generated = useId();
    const id = idPrefix || `contact-name-${generated}`;
    const namedParts = () => firstName !== undefined && firstName !== null ? { firstName, lastName: lastName || '', review: false } : splitContactName(value);
    const [parts, setParts] = useState(namedParts);
    const emitted = useRef(value);
    const latestParts = useRef(parts);
    useEffect(() => {
        if (value !== emitted.current) { emitted.current = value; const next = namedParts(); latestParts.current = next; setParts(next); }
    // External values change on contact selection; local keystrokes keep their cursor.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, firstName, lastName]);
    const change = (key, text) => {
        const next = { ...latestParts.current, [key]: text, review: false };
        latestParts.current = next;
        setParts(next);
        emitted.current = [next.firstName, next.lastName].map(value => value.trim()).filter(Boolean).join(' ');
        onChange?.(emitted.current, next);
    };
    return <div className="grid gap-2 sm:grid-cols-2" data-contact-name-fields="true">
        {['firstName', 'lastName'].map((key, index) => <div key={key}>
            <label className={labelClassName} htmlFor={`${id}-${key}`}>{index ? 'Last name' : 'First name'}</label>
            <input id={`${id}-${key}`} autoComplete={index ? 'family-name' : 'given-name'} className={className}
                value={parts[key]} disabled={disabled} onChange={e => change(key, e.target.value)} />
        </div>)}
        {parts.review && <p className="text-sm col-span-full" role="status">Review existing name: {value}. Enter the person’s first and last name.</p>}
    </div>;
}
